import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceProcessingExceptionTable extends Layout {
    labelInvoiceExceptions: Label;
    panelExceptions: Panel;
    sourceInvoiceProcessingException: DataSource;
    tableInvoiceException: Table;
}
